import type { TypeInputState } from '~/types/common.types';

/**
 * [화주사 정보 관리] 페이지네이션 관련 상수
 */
export const INITIAL_VENDER_PAGE_CURSOR = 1;

export const VENDER_PAGE_SIZE = {
  50: {
    value: 50,
    text: '50개',
  },
  100: {
    value: 100,
    text: '100개',
  },
  200: {
    value: 200,
    text: '200개',
  },
} as const;

/**
 * [화주사 정보 관리] Date 요청 포맷
 */
export const VENDER_DATE_FORMAT = {
  DATE_TIME: 'YYYY-MM-DDTHH:mm:ss',
  DATE: 'YYYY.MM.DD',
};

/**
 * [화주사 정보 관리] 에러 상태
 */
export const ERROR_BUSINESS_NUMBER_SEARCH_STATUS = {
  status: 'error',
  message: '사업자번호를 [조회]해주세요.',
} as TypeInputState;

export const ERROR_DUPLICATED_BUSINESS_NUMBER_STATUS = {
  status: 'error',
  message: '이미 등록된 사업자번호 입니다.',
} as TypeInputState;

/**
 * [화주사 정보 관리] 화주사 담당자 최대 인원 수
 */
export const VENDER_MANAGER_MAX_COUNT = 20;
